import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "settings-icon" }
const _hoisted_2 = { class: "icon-bg" }

export function render(_ctx, _cache) {
  const _component_Icon = _resolveComponent("Icon")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Icon, {
        width: "5rem",
        height: "5rem",
        icon: "settings-01",
        stroke: "var(--brand-500)"
      })
    ])
  ]))
}